module.exports = __webpack_public_path__ + "static/img/zsyz-bg.8c37312.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/zsyz-bg.png
// module id = FA+X
// module chunks = 1